/**
 * Variant Picker Position - A/B Test
 * Controlled via PostHog feature flag "variant-picker-position"
 *
 * Control (A): Variant picker in its default position (after description).
 * Test (B):    Variant picker moved directly after rating/price block.
 *
 * Primary goal: CVR (Conversion Rate)
 */
(function() {
  'use strict';

  var MAX_RETRIES = 25; // 25 x 200ms = 5s max wait

  function whenPostHogReady(cb, attempt) {
    attempt = attempt || 0;
    if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
      window.posthog.onFeatureFlags(cb);
    } else if (attempt < MAX_RETRIES) {
      setTimeout(function() { whenPostHogReady(cb, attempt + 1); }, 200);
    }
  }

  // Extracts the product handle from a pathname like "/products/<handle>".
  // Returns '' for non-product paths. Pure (no DOM); unit tested.
  function productHandleFromPath(pathname) {
    return (String(pathname || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';
  }

  whenPostHogReady(function() {
    var flagValue = window.posthog.getFeatureFlag('variant-picker-position');

    if (flagValue !== 'test') {
      return; // Control group: default position
    }

    var productInfo = document.querySelector('.product-info');
    if (!productInfo) return;

    var variantPicker = productInfo.querySelector('.product-info__variant-picker');
    if (!variantPicker) return;

    // Rating is rendered inside .product-info__price when price is followed
    // by rating in block_order (the common case). Fall back to standalone
    // .product-info__rating if the template uses a different order.
    var anchor = productInfo.querySelector('.product-info__price')
      || productInfo.querySelector('.product-info__rating');
    if (!anchor) return;

    // Avoid moving if variant picker is already directly after the anchor
    if (anchor.nextElementSibling === variantPicker) return;

    var anchorType = anchor.classList.contains('product-info__price') ? 'price' : 'rating';

    anchor.after(variantPicker);

    window.posthog.capture('variant_picker_position_shown', {
      variant: 'test',
      anchor_used: anchorType,
      page_url: window.location.pathname,
      product_handle: productHandleFromPath(window.location.pathname)
    });
  });

  // Expose pure/polling helpers for unit tests (consistent with __dpState/__dpApi).
  window.__variantPickerAbTest = {
    whenPostHogReady: whenPostHogReady,
    productHandleFromPath: productHandleFromPath
  };
})();
